var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect, useMemo } from 'react';
import { CaseApplicantsDetails } from '../case-applicant-details';
import './client-details.scss';
export var ClientDetails = function (_a) {
    var applicant = _a.applicant, fetchData = _a.fetchData, documentList = _a.documentList, onUpdate = _a.onUpdate, showUploadModal = _a.showUploadModal;
    var _b = useState([]), displayData = _b[0], setDisplayData = _b[1];
    var _c = useState(), applicantDetails = _c[0], setApplicantDetails = _c[1];
    var documentGridRefresh = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (applicant === null || applicant === void 0 ? void 0 : applicant.customerId) {
                fetchData(applicant === null || applicant === void 0 ? void 0 : applicant.customerId)
                    .then(function (result) {
                    setDisplayData(result);
                })
                    .catch(function () {
                    setDisplayData([]);
                });
            }
            return [2 /*return*/];
        });
    }); };
    var updateApplicantDetails = function (updatedCustomerDetails) {
        var newApplicantDetails = {
            id: applicant === null || applicant === void 0 ? void 0 : applicant.id,
            email: updatedCustomerDetails === null || updatedCustomerDetails === void 0 ? void 0 : updatedCustomerDetails.email,
            firstName: updatedCustomerDetails === null || updatedCustomerDetails === void 0 ? void 0 : updatedCustomerDetails.firstName,
            mobileNumber: updatedCustomerDetails === null || updatedCustomerDetails === void 0 ? void 0 : updatedCustomerDetails.mobileNumber,
            surname: updatedCustomerDetails === null || updatedCustomerDetails === void 0 ? void 0 : updatedCustomerDetails.surname,
            titleID: updatedCustomerDetails === null || updatedCustomerDetails === void 0 ? void 0 : updatedCustomerDetails.titleId,
            dateOfBirth: updatedCustomerDetails === null || updatedCustomerDetails === void 0 ? void 0 : updatedCustomerDetails.dateOfBirth,
            addressId: updatedCustomerDetails === null || updatedCustomerDetails === void 0 ? void 0 : updatedCustomerDetails.addressId,
        };
        setApplicantDetails(newApplicantDetails);
    };
    useEffect(function () {
        documentList ? setDisplayData(documentList) : documentGridRefresh();
    }, [documentList, applicant]);
    var renderApplicantsDetails = useMemo(function () { return (React.createElement(CaseApplicantsDetails, { applicant: applicantDetails !== null && applicantDetails !== void 0 ? applicantDetails : applicant, clientId: applicant === null || applicant === void 0 ? void 0 : applicant.customerId, documents: displayData, documentGridRefresh: documentGridRefresh, onUpdate: onUpdate, updateApplicants: updateApplicantDetails, showUploadModal: showUploadModal })); }, [applicant, displayData, applicantDetails]);
    return React.createElement("div", null, renderApplicantsDetails);
};
